import React from 'react';
import { ServiceAuth } from '../../services/service-auth';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import BtButton from '../bt-button/bt-button';
import AppLabel from '../app-label/app-label';
import { withTranslation } from 'react-i18next';

import '../app-login/app-login.css';
import Logo from '../../components/svgs/logo';
import { showErrorNotification, showSuccessNotification } from '../../util';

export class AppChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changePassword: false,
      btnLoginLoaderShow: false,
      errorMessage: '',
      errorShow: false,
      email: '',
    };
    this.confirmPassword = React.createRef();
    this.newPassword = React.createRef();
    this.oldPassword = React.createRef();
  }

  componentWillLoad() {
    if (ServiceAuth.isLoggedIn) {
      this.history.replace('/dashboard');
    }
  }

  async componentDidMount() {
    const changePassword = _.get(this, 'props.changePassword');

    this.setState({ changePassword });
    if (!changePassword) await this.getUserData();
  }

  getUserData = async () => {
    let userData;
    const verificationcode = _.get(this, 'props.match.params.verificationcode');

    if (verificationcode) {
      userData = await ServiceAuth.getUserFromVerificationCode(verificationcode);
    }
    if (userData) {
      this.setState({ email: userData.email });
    } else {
      this.props.history.replace('/error');
    }
  };

  btnSubmitPasswordClickCallback = () => {
    this.submitRequest();
  };

  async submitRequest() {
    const { t } = this.props;
    try {
      if (this.state.btnLoginLoaderShow) {
        return;
      }

      const newPassword = this.newPassword.current.value;
      const confirmPassword = this.confirmPassword.current.value;

      if (newPassword !== confirmPassword) {
        return showErrorNotification(
          t('notification.error.passwordMismatch.decription', 'Kontrollera att "Nytt lösenord" och "Bekräfta lösenord" matchar.'),
          t('notification.error.passwordMismatch.title', 'Lösenorden stämmer inte'),
        );
      }

      this.setState({ btnLoginLoaderShow: true, errorShow: false, errorMessage: '' });

      if (this.state.changePassword) {
        await this.handleChangePassword();
      } else {
        await this.handleForgotPassword();
      }
      this.resetFields();
    } catch (e) {
      console.log(e, 'error in app-change-password');
      this.setState({ btnLoginLoaderShow: false, errorShow: true, errorMessage: e.response.data.error });
    }
  }

  handleForgotPassword = async () => {
    const verificationKey = _.get(this, 'props.match.params.verificationcode');
    const confirmPassword = this.confirmPassword.current.value;
    const response = await ServiceAuth.changePassword(confirmPassword, verificationKey);
    this.handleResponse(response);
    this.props.history.push('/');
  }

  handleChangePassword = async () => {
    const oldPassword = this.oldPassword.current.value;
    const confirmPassword = this.confirmPassword.current.value;
    const response = await ServiceAuth.changeUserPassword(oldPassword, confirmPassword);
    this.handleResponse(response);
  };

  handleResponse = (response) => {
    if (response.responseStatus === 'error') {
      return showErrorNotification(response.message);
    }
    if (response.responseStatus === 'success') {
      return showSuccessNotification(response.message);
    }
  };

  resetFields = () => {
    this.setState({ btnLoginLoaderShow: false, errorShow: false, errorMessage: '' });
    this.newPassword.current.value = '';
    this.confirmPassword.current.value = '';
    if (this.state.changePassword) this.oldPassword.current.value = '';
  };

  render() {
    const { t } = this.props;
    const { btnLoginLoaderShow, errorShow, errorMessage, email, changePassword } = this.state;
    return (
      <div className="app-login forgot-pass-form-wrapper">
        {!changePassword && <Logo size="350px" type="logoWithTitle" />}

        <div className="input-wrapper" style={{ marginTop: '0' }}>
          {changePassword ? (
            <React.Fragment>
              <AppLabel class="ar-label v2" headline={t('label.email', 'E-postadress')}>
                <input
                  className="ar-text-field disabled mb-c-6"
                  placeholder={t('label.email', 'E-postadress')}
                  disabled
                  name="E-postadress"
                  defaultValue={this.props.email}
                />
              </AppLabel>
              <AppLabel class="ar-label v2" headline={t('label.oldPassword', 'Gammalt lösenord')}>
                <input
                  className="ar-text-field"
                  placeholder={t('label.oldPassword', 'Gammalt lösenord')}
                  autoCapitalize="off"
                  autoComplete="new-password"
                  name="oldPassword"
                  type="password"
                  ref={this.oldPassword}
                />
              </AppLabel>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="title">{t('resetPassword.title', 'Återställ ditt lösenord')}</div>
              <AppLabel class="ar-label" headline={t('label.email', 'E-postadress')}>
                <input
                  className="ar-text-field disabled mb-c-6"
                  placeholder={t('label.email', 'E-postadress')}
                  disabled={true}
                  name="E-postadress"
                  defaultValue={email}
                />
              </AppLabel>
            </React.Fragment>
          )}
          <AppLabel class={`ar-label ${changePassword && 'v2'}`} headline={t('label.newPassword', 'Nytt lösenord')}>
            <input
              className="ar-text-field"
              placeholder={t('label.newPassword', 'Nytt lösenord')}
              autoCapitalize="off"
              name="newPassword"
              type="password"
              ref={this.newPassword}
            />
          </AppLabel>
          <AppLabel class={`ar-label ${changePassword && 'v2'}`} headline={t('label.confirmPassword', 'Bekräfta lösenord')}>
            <input
              className="ar-text-field"
              placeholder={t('label.confirmPassword', 'Bekräfta lösenord')}
              autoCapitalize="off"
              name="confirmPassword"
              type="password"
              ref={this.confirmPassword}
            />
          </AppLabel>

          <div className="btn-login-wrapper">
            <BtButton
              class="ar-button primary"
              loaderShow={btnLoginLoaderShow}
              onClick={this.btnSubmitPasswordClickCallback}
            >
              {t('saveButton', 'Spara')}
            </BtButton>
          </div>
        </div>
        <p className={`error ${errorShow ? 'show' : 'hide'}`}>
          { errorMessage || t('validation.fallbackError', 'Alla lösenordsfält krävs') }
        </p>
      </div>
    );
  }
}

export default withRouter(withTranslation('profile')(AppChangePassword));
